export const HubspotFeatures = [
    { name: "Custom Fields", type: "Only in Higher Plans" },
    { name: "Full Call Centre Software", type: "No" },
    { name: "Integrated WhatsApp For Business Support (with full Automation like MakeMyTrip)*", type: "No" },
    { name: "Workflow Management - Automate lead & sales management", type: "No" },
    { name: "Booking Form with Support for Agreement + Brokerage Calculations", type: "No" },
    { name: "Insta Connect - For Instant Auto connected Call back to Customers", type: "No" },
    { name: "Create & Track Price Quotes", type: "No" },
    { name: "Schemes & Discounts", type: "No" },
    { name: "Connected Facebook Adverts Tracking - Auto CPL calculations & Dashboards", type: "Steep Pricing under Marketing License" },
    { name: "Drip Marketing", type: "Yes" },
    { name: "Inventory management - projects, towers, configurations and units", type: "No" },
    { name: "Customer Access & Online Interface", type: "No" },
    { name: "Online Bookings, Schemes & Discounts", type: "No" },
    { name: "ISO 27001 Certified Data Security & Compliance", type: "Yes" }
];
export default HubspotFeatures;
